(function(angular){
	'use strict';

	angular
		.module('allocationBreakdownTableModule')
		.directive('allocationBreakdownTable', [
			'APP_BASE_PATH',
			'STATIC_BASE_PATH',
			AllocationBreakdownTableFunction
		]);

	function AllocationBreakdownTableFunction(
		APP_BASE_PATH,
		STATIC_BASE_PATH
	) {
		return {
			restrict: 'E',
			templateUrl: STATIC_BASE_PATH + '/' + 'static/html/allocation-breakdown/allocation-breakdown-table.html',
			scope: {
				allocation: '='
			},
			link: function($scope, $element, $attrs) {
				$scope.basePath = APP_BASE_PATH;
			}
		};
	}
})(window.angular);